<ion-header>
  <ion-toolbar>
    <ion-title>Choose location</ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onSaveClick()">Save</ion-button>
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  
  <google-map height="400px"
            width="750px"
            [center]="center"
            [zoom]="zoom">
        <map-marker #markerRef="mapMarker"
            *ngFor="let marker of markers"
            [position]="marker.position"
            [label]="marker.label"
            [title]="marker.title"
            [draggable]="marker.draggable"
            [options]="marker.options" (mapClick)="openInfoWindow(markerRef)" (mapDragend)="openInfoWindow(markerRef)"
            
         ></map-marker>
        <map-info-window>{{infoWindowContent}}          
        </map-info-window>
      </google-map>
    
</ion-content>
